export const version = {"baseVersion":1369,"versionDate":"2026-10-29T20:37:46.426Z","branch":"sandbox","app":"backoffice","textVersion":"1.3.69"}